import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="app-footer">
    <div className="app-footer-inner">
      <span className="app-footer-brand">© {new Date().getFullYear()} MyDocAI</span>
      <div className="app-footer-links">
        <Link to="/privacy">Privacy Policy</Link>
        <span className="app-footer-sep">·</span>
        <Link to="/terms">Terms of Service</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
